import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import CtaFinal from "@/components/CtaFinal";
import { Reveal, MaskedLineInView, Eyebrow } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const Servizi = () => (
  <>
    <SEO
      title="Servizi Edili — SOPAJ | Ristrutturazioni, Bagni, Cucine, Pavimenti a Nibionno e Lecco"
      description="Ristrutturazioni complete, opere murarie, rifacimento bagni e cucine, pavimenti, cartongesso, tinteggiature, esterni e manutenzioni edili a Nibionno, Lecco, Brianza e in altre località."
      path="/servizi"
    />

    <section data-testid="servizi-hero" className="max-w-7xl mx-auto px-5 md:px-8 pt-36 md:pt-48 pb-16 md:pb-24">
      <Reveal><Eyebrow number="01" label="Servizi" /></Reveal>
      <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-anthracite max-w-4xl">
        <MaskedLineInView>Tutto ciò che serve</MaskedLineInView>
        <MaskedLineInView delay={0.1}>
          <span className="font-serif italic font-normal">per ristrutturare casa.</span>
        </MaskedLineInView>
      </h1>
      <Reveal delay={0.2}>
        <p className="mt-8 max-w-2xl text-anthracite/75 leading-relaxed text-base md:text-lg">
          Dalla singola lavorazione alla ristrutturazione completa: seguiamo ogni
          intervento con la stessa cura, dalla zona di Nibionno, Lecco e Brianza
          ad altre località, in base alle caratteristiche del progetto.
        </p>
      </Reveal>
    </section>

    <section className="max-w-7xl mx-auto px-5 md:px-8 pb-24 md:pb-36">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={(i % 3) * 0.08}>
            <Link to={`/${s.slug}`} data-testid={`service-card-${s.slug}`} className="group block">
              <div className="overflow-hidden aspect-[4/3] bg-sand">
                <img
                  src={s.img}
                  alt={`${s.title} — Sopaj impresa edile, Nibionno (LC)`}
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="mt-6 flex items-start justify-between gap-4">
                <div>
                  <p className="font-display text-xs tracking-[0.25em] text-terracotta">{String(i + 1).padStart(2, "0")}</p>
                  <h2 className="mt-2 font-display text-2xl tracking-tight text-anthracite group-hover:text-terracotta transition-colors duration-300">
                    {s.title}
                  </h2>
                  <p className="mt-3 text-sm text-concrete leading-relaxed">{s.text}</p>
                </div>
                <ArrowRight size={18} strokeWidth={1.5} className="mt-8 shrink-0 text-anthracite/30 transition-all duration-300 group-hover:text-terracotta group-hover:translate-x-1" />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-20 md:mt-28 bg-anthracite text-ivory p-10 md:p-14 flex flex-col md:flex-row md:items-center justify-between gap-8 grain relative">
          <div>
            <h2 className="font-display text-2xl md:text-3xl tracking-tight">Non trovi il lavoro che ti serve?</h2>
            <p className="mt-3 text-ivory/60 text-sm md:text-base max-w-lg">
              Raccontaci l'intervento che hai in mente: valutiamo insieme fattibilità,
              tempi e modalità durante un sopralluogo.
            </p>
          </div>
          <Link
            to="/contatti"
            data-testid="servizi-cta-sopralluogo"
            className="group inline-flex items-center justify-center gap-3 bg-terracotta hover:bg-terracotta-hover text-ivory font-display text-sm tracking-[0.15em] uppercase px-8 py-4 shrink-0 transition-colors duration-300"
          >
            Raccontaci il tuo progetto
            <ArrowRight size={16} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </section>

    <CtaFinal />
  </>
);

export default Servizi;
